import React from 'react';
import MUITextField from '@mui/material/TextField';
import NumberTextField from './NumberTextField.jsx';

const TextField = (props) => {
	const {
		htmlType,
		errorMessage,
		helperText,
		...rest
	} = props;

	if (htmlType) {
		rest.type = htmlType;

		if (htmlType === 'number') {
			return (
				<NumberTextField
					error={errorMessage}
					helperText={helperText}
					{...rest}
				/>
			);
		}
	}

	return (
		<MUITextField
			fullWidth
			error={!!errorMessage}
			helperText={errorMessage || helperText}
			{...rest}
		/>
	);
};


TextField.type = 'TextField';

TextField.spec = [{
	name: 'TextField',
	key: 'TextField',
	icon: 'Type',
	title: 'Text field',
	category: 'input',
	translatable: ['label', 'placeholder'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'TextField',
		label: 'Placeholder',
		name: 'placeholder',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}],
}, {
	name: 'TextField',
	key: 'Email',
	title: 'Email',
	icon: 'AtSign',
	category: 'input',
	translatable: ['label', 'placeholder'],
	defaultProperties: {
		label: 'Email',
		placeholder: 'email',
		//TODO create name based on prev
		name: 'email',
		validators: [{
			name: 'isEmail',
			errorKey: 'emailRequired',
		}],
		errorMessages: {
			emailRequired: 'email is required',
		},
	},
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'TextField',
		label: 'Placeholder',
		name: 'placeholder',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}],
}];
export default TextField;
